export default __webpack_public_path__ + "static/media/graphic_web.3123eb0a.png";